import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldConfigureEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-configure-edit',
	path: '/secure/admin/EditDefaultFieldLayoutItem!default.jspa',
};
